import dateFormat from 'dateformat'

export const formatDate = (value) => {
    return dateFormat(value, "yyyy-mm-dd");
}